import { SB } from '@play-co/replicant';

export const slotSchema = {
  slots: SB.object({
    rewards: SB.array(
      SB.union([
        SB.object({
          type: SB.tuple([
            'energy',
            'gems',
            'bPoints',
            'frenzyPoints',
          ] as const),
          count: SB.int(),
          bonus: SB.int().optional(),
        }),
        SB.object({
          type: SB.tuple(['care'] as const),
          id: SB.string(),
          count: SB.int(),
        }),
        SB.object({
          type: SB.tuple(['minigame'] as const),
          id: SB.string(),
          count: SB.int(),
          bonus: SB.int().optional(),
        }),
      ]),
    ),
    multiplier: SB.int().default(1).min(1),
  }).optional(),
};
